import { FC } from 'react';

import {
  useContractEditStore,
  useContractListStore,
} from 'page/CustomerPage/hooks';
import { ContractConfirmationModalView } from 'page/CustomerPage/components/ContractConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickUpdate: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickUpdate,
}) => {
  const {
    isOpenConfirmationModal,
    menuName,
    displayValid,
    displayStartDate,
    displayEndDate,
  } = useContractEditStore();
  const { selectedContract } = useContractListStore();

  return (
    <>
      {/* 契約メニューの確認モーダル */}
      <ContractConfirmationModalView
        mode="更新"
        isOpen={isOpenConfirmationModal}
        contractId={selectedContract?.id}
        menuName={menuName}
        displayValid={displayValid}
        displayStartDate={displayStartDate}
        displayEndDate={displayEndDate}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickExecution={handleClickUpdate}
      />
    </>
  );
};
